// GENERATED FILE - do not edit by hand.
// Produced by scripts/buildCardData.mjs from scripts/source-data/*.js.
// Re-run "node scripts/buildCardData.mjs" after changing the source data.

export const copyCounts = {
  "hero-aeon-l1": {
    "total": 6
  },
  "hero-aeon-l2": {
    "total": 4
  },
  "hero-aeon-l3": {
    "total": 2
  },
  "hero-aird-l1": {
    "total": 6
  },
  "hero-aird-l2": {
    "total": 4
  },
  "hero-aird-l3": {
    "total": 2
  },
  "hero-armsman-l1": {
    "total": 6
  },
  "hero-armsman-l2": {
    "total": 4
  },
  "hero-armsman-l3": {
    "total": 2
  },
  "hero-bhoidwood-l1": {
    "total": 6
  },
  "hero-bhoidwood-l2": {
    "total": 4
  },
  "hero-bhoidwood-l3": {
    "total": 2
  },
  "hero-blackhand-l1": {
    "total": 6
  },
  "hero-blackhand-l2": {
    "total": 4
  },
  "hero-blackhand-l3": {
    "total": 2
  },
  "hero-blademage-l1": {
    "total": 6
  },
  "hero-blademage-l2": {
    "total": 4
  },
  "hero-blademage-l3": {
    "total": 2
  },
  "hero-blind-l1": {
    "total": 6
  },
  "hero-blind-l2": {
    "total": 4
  },
  "hero-blind-l3": {
    "total": 2
  },
  "hero-blind-l4": {
    "total": 1
  },
  "hero-bluefire-l1": {
    "total": 6
  },
  "hero-bluefire-l2": {
    "total": 4
  },
  "hero-bluefire-l3": {
    "total": 2
  },
  "hero-bluefire-l4": {
    "total": 1
  },
  "hero-caliginite-l1": {
    "total": 6
  },
  "hero-caliginite-l2": {
    "total": 4
  },
  "hero-caliginite-l3": {
    "total": 2
  },
  "hero-cathedral-l1": {
    "total": 6
  },
  "hero-cathedral-l2": {
    "total": 4
  },
  "hero-cathedral-l3": {
    "total": 2
  },
  "hero-chalice-l1": {
    "total": 6
  },
  "hero-chalice-l2": {
    "total": 4
  },
  "hero-chalice-l3": {
    "total": 2
  },
  "hero-chalice-l4": {
    "total": 1
  },
  "hero-charming-l1": {
    "total": 6
  },
  "hero-charming-l2": {
    "total": 4
  },
  "hero-charming-l3": {
    "total": 2
  },
  "hero-clan-l1": {
    "total": 6
  },
  "hero-clan-l2": {
    "total": 4
  },
  "hero-clan-l3": {
    "total": 2
  },
  "hero-clan-l4": {
    "total": 1
  },
  "hero-clever-l1": {
    "total": 6
  },
  "hero-clever-l2": {
    "total": 4
  },
  "hero-clever-l3": {
    "total": 2
  },
  "hero-criochan-l1": {
    "total": 6
  },
  "hero-criochan-l2": {
    "total": 4
  },
  "hero-criochan-l3": {
    "total": 2
  },
  "hero-dark-l1": {
    "total": 6
  },
  "hero-dark-l2": {
    "total": 4
  },
  "hero-dark-l3": {
    "total": 2
  },
  "hero-dark-l4": {
    "total": 1
  },
  "hero-deepstrider-l1": {
    "total": 6
  },
  "hero-deepstrider-l2": {
    "total": 4
  },
  "hero-deepstrider-l3": {
    "total": 2
  },
  "hero-disowned-l1": {
    "total": 6
  },
  "hero-disowned-l2": {
    "total": 4
  },
  "hero-disowned-l3": {
    "total": 2
  },
  "hero-divine-l1": {
    "total": 6
  },
  "hero-divine-l2": {
    "total": 4
  },
  "hero-divine-l3": {
    "total": 2
  },
  "hero-divine-l4": {
    "total": 1
  },
  "hero-drua-l1": {
    "total": 6
  },
  "hero-drua-l2": {
    "total": 4
  },
  "hero-drua-l3": {
    "total": 2
  },
  "hero-forcemage-l1": {
    "total": 6
  },
  "hero-forcemage-l2": {
    "total": 4
  },
  "hero-forcemage-l3": {
    "total": 2
  },
  "hero-garrison-l1": {
    "total": 6
  },
  "hero-garrison-l2": {
    "total": 4
  },
  "hero-garrison-l3": {
    "total": 2
  },
  "hero-glamercast-l1": {
    "total": 6
  },
  "hero-glamercast-l2": {
    "total": 4
  },
  "hero-glamercast-l3": {
    "total": 2
  },
  "hero-gohlen-l1": {
    "total": 6
  },
  "hero-gohlen-l2": {
    "total": 4
  },
  "hero-gohlen-l3": {
    "total": 2
  },
  "hero-gohlen-l4": {
    "total": 1
  },
  "hero-graceful-l1": {
    "total": 6
  },
  "hero-graceful-l2": {
    "total": 4
  },
  "hero-graceful-l3": {
    "total": 2
  },
  "hero-grim-l1": {
    "total": 6
  },
  "hero-grim-l2": {
    "total": 4
  },
  "hero-grim-l3": {
    "total": 2
  },
  "hero-grim-l4": {
    "total": 1
  },
  "hero-harruli-l1": {
    "total": 6
  },
  "hero-harruli-l2": {
    "total": 4
  },
  "hero-harruli-l3": {
    "total": 2
  },
  "hero-harruli-l4": {
    "total": 1
  },
  "hero-honormain-l1": {
    "total": 6
  },
  "hero-honormain-l2": {
    "total": 4
  },
  "hero-honormain-l3": {
    "total": 2
  },
  "hero-intelligent-l1": {
    "total": 6
  },
  "hero-intelligent-l2": {
    "total": 4
  },
  "hero-intelligent-l3": {
    "total": 2
  },
  "hero-isri-l1": {
    "total": 6
  },
  "hero-isri-l2": {
    "total": 4
  },
  "hero-isri-l3": {
    "total": 2
  },
  "hero-isri-l4": {
    "total": 1
  },
  "hero-learned-l1": {
    "total": 6
  },
  "hero-learned-l2": {
    "total": 4
  },
  "hero-learned-l3": {
    "total": 2
  },
  "hero-lorigg-l1": {
    "total": 6
  },
  "hero-lorigg-l2": {
    "total": 4
  },
  "hero-lorigg-l3": {
    "total": 2
  },
  "hero-lorigg-l4": {
    "total": 1
  },
  "hero-moonclaw-l1": {
    "total": 6
  },
  "hero-moonclaw-l2": {
    "total": 4
  },
  "hero-moonclaw-l3": {
    "total": 2
  },
  "hero-mystic-l1": {
    "total": 6
  },
  "hero-mystic-l2": {
    "total": 4
  },
  "hero-mystic-l3": {
    "total": 2
  },
  "hero-outlands-l1": {
    "total": 6
  },
  "hero-outlands-l2": {
    "total": 4
  },
  "hero-outlands-l3": {
    "total": 2
  },
  "hero-outlands-l4": {
    "total": 1
  },
  "hero-patternmage-l1": {
    "total": 6
  },
  "hero-patternmage-l2": {
    "total": 4
  },
  "hero-patternmage-l3": {
    "total": 2
  },
  "hero-profaned-l1": {
    "total": 6
  },
  "hero-profaned-l2": {
    "total": 4
  },
  "hero-profaned-l3": {
    "total": 2
  },
  "hero-rapparee-l1": {
    "total": 6
  },
  "hero-rapparee-l2": {
    "total": 4
  },
  "hero-rapparee-l3": {
    "total": 2
  },
  "hero-regian-l1": {
    "total": 6
  },
  "hero-regian-l2": {
    "total": 4
  },
  "hero-regian-l3": {
    "total": 2
  },
  "hero-regian-l4": {
    "total": 1
  },
  "hero-rugged-l1": {
    "total": 6
  },
  "hero-rugged-l2": {
    "total": 4
  },
  "hero-rugged-l3": {
    "total": 2
  },
  "hero-silvertongue-l1": {
    "total": 6
  },
  "hero-silvertongue-l2": {
    "total": 4
  },
  "hero-silvertongue-l3": {
    "total": 2
  },
  "hero-skinshifter-l1": {
    "total": 6
  },
  "hero-skinshifter-l2": {
    "total": 4
  },
  "hero-skinshifter-l3": {
    "total": 2
  },
  "hero-spellsword-l1": {
    "total": 6
  },
  "hero-spellsword-l2": {
    "total": 4
  },
  "hero-spellsword-l3": {
    "total": 2
  },
  "hero-stealthy-l1": {
    "total": 6
  },
  "hero-stealthy-l2": {
    "total": 4
  },
  "hero-stealthy-l3": {
    "total": 2
  },
  "hero-sternnkin-l1": {
    "total": 6
  },
  "hero-sternnkin-l2": {
    "total": 4
  },
  "hero-sternnkin-l3": {
    "total": 2
  },
  "hero-stoneguard-l1": {
    "total": 6
  },
  "hero-stoneguard-l2": {
    "total": 4
  },
  "hero-stoneguard-l3": {
    "total": 2
  },
  "hero-stoneguard-l4": {
    "total": 1
  },
  "hero-strong-l1": {
    "total": 6
  },
  "hero-strong-l2": {
    "total": 4
  },
  "hero-strong-l3": {
    "total": 2
  },
  "hero-strongwilled-l1": {
    "total": 6
  },
  "hero-strongwilled-l2": {
    "total": 4
  },
  "hero-strongwilled-l3": {
    "total": 2
  },
  "hero-swift-l1": {
    "total": 6
  },
  "hero-swift-l2": {
    "total": 4
  },
  "hero-swift-l3": {
    "total": 2
  },
  "hero-thornwood-l1": {
    "total": 6
  },
  "hero-thornwood-l2": {
    "total": 4
  },
  "hero-thornwood-l3": {
    "total": 2
  },
  "hero-thornwood-l4": {
    "total": 1
  },
  "hero-tholis-l1": {
    "total": 6
  },
  "hero-tholis-l2": {
    "total": 4
  },
  "hero-tholis-l3": {
    "total": 2
  },
  "hero-tholis-l4": {
    "total": 1
  },
  "hero-thundermage-l1": {
    "total": 6
  },
  "hero-thundermage-l2": {
    "total": 4
  },
  "hero-thundermage-l3": {
    "total": 2
  },
  "hero-tough-l1": {
    "total": 6
  },
  "hero-tough-l2": {
    "total": 4
  },
  "hero-tough-l3": {
    "total": 2
  },
  "hero-tower-l1": {
    "total": 6
  },
  "hero-tower-l2": {
    "total": 4
  },
  "hero-tower-l3": {
    "total": 2
  },
  "hero-tuath-l1": {
    "total": 6
  },
  "hero-tuath-l2": {
    "total": 4
  },
  "hero-tuath-l3": {
    "total": 2
  },
  "hero-veilminder-l1": {
    "total": 6
  },
  "hero-veilminder-l2": {
    "total": 4
  },
  "hero-veilminder-l3": {
    "total": 2
  },
  "hero-verdan-l1": {
    "total": 6
  },
  "hero-verdan-l2": {
    "total": 4
  },
  "hero-verdan-l3": {
    "total": 2
  },
  "hero-verdan-l4": {
    "total": 1
  },
  "hero-veris-l1": {
    "total": 6
  },
  "hero-veris-l2": {
    "total": 4
  },
  "hero-veris-l3": {
    "total": 2
  },
  "hero-veris-l4": {
    "total": 1
  },
  "hero-whetmage-l1": {
    "total": 6
  },
  "hero-whetmage-l2": {
    "total": 4
  },
  "hero-whetmage-l3": {
    "total": 2
  },
  "hero-wildwood-l1": {
    "total": 6
  },
  "hero-wildwood-l2": {
    "total": 4
  },
  "hero-wildwood-l3": {
    "total": 2
  },
  "hero-woodfolk-l1": {
    "total": 6
  },
  "hero-woodfolk-l2": {
    "total": 4
  },
  "hero-woodfolk-l3": {
    "total": 2
  },
  "hero-woodfolk-l4": {
    "total": 1
  },
  "hero-woodguard-l1": {
    "total": 6
  },
  "hero-woodguard-l2": {
    "total": 4
  },
  "hero-woodguard-l3": {
    "total": 2
  },
  "hero-xenomorph-l1": {
    "total": 6
  },
  "hero-xenomorph-l2": {
    "total": 4
  },
  "hero-xenomorph-l3": {
    "total": 2
  },
  "hero-xenomorph-l4": {
    "total": 1
  },
  "monster-murden": {
    "total": 2
  },
  "monster-chirog": {
    "total": 2
  },
  "monster-margr": {
    "total": 2
  },
  "monster-sathosh": {
    "total": 2
  },
  "monster-culova": {
    "total": 2
  },
  "monster-archduke-of-pain": {
    "total": 1
  },
  "monster-grudgebeast": {
    "total": 2
  },
  "monster-tormentor": {
    "total": 2
  },
  "monster-succubus": {
    "total": 2
  },
  "monster-the-unchained": {
    "total": 3
  },
  "monster-doomspawn": {
    "total": 10
  },
  "monster-death-polyps": {
    "total": 1
  },
  "monster-ghost-toxin": {
    "total": 2
  },
  "monster-snakewyrm": {
    "total": 2
  },
  "monster-spike-lasher": {
    "total": 3
  },
  "monster-spider-bloat": {
    "total": 2
  },
  "monster-razorback": {
    "total": 2
  },
  "monster-the-bloodless": {
    "total": 2
  },
  "monster-regicide": {
    "total": 2
  },
  "monster-tendril-minion": {
    "total": 2
  },
  "monster-usurper": {
    "total": 2
  },
  "monster-lavrik-ca": {
    "total": 1
  },
  "monster-stellar-weaver": {
    "total": 3
  },
  "monster-penumbra-fiend": {
    "total": 2
  },
  "monster-philethis": {
    "total": 2
  },
  "monster-syzygy-ghoul": {
    "total": 2
  },
  "monster-disassembler": {
    "total": 2
  },
  "monster-zhev": {
    "total": 2
  },
  "monster-mastigophore": {
    "total": 2
  },
  "monster-dark-fathom": {
    "total": 2
  },
  "monster-guardian-automaton": {
    "total": 2
  },
  "monster-blood-barm": {
    "total": 2
  },
  "monster-thuman": {
    "total": 2
  },
  "monster-broken-hound": {
    "total": 2
  },
  "monster-ithsyn": {
    "total": 2
  },
  "monster-seskii": {
    "total": 2
  },
  "monster-mounted-raider": {
    "total": 2
  },
  "monster-bandit-taskmaster": {
    "total": 2
  },
  "monster-bandit-killer": {
    "total": 2
  },
  "monster-bandit-warlord": {
    "total": 2
  },
  "monster-bandit-warrior": {
    "total": 2
  },
  "monster-red-gronek": {
    "total": 2
  },
  "monster-faceless-colossus": {
    "total": 2
  },
  "monster-hulking-yeti": {
    "total": 2
  },
  "monster-blue-gronek": {
    "total": 2
  },
  "monster-cyclopic-horror": {
    "total": 2
  },
  "monster-ophidian-cutter": {
    "total": 2
  },
  "monster-gnoll-ravager": {
    "total": 2
  },
  "monster-kobold-meddler": {
    "total": 2
  },
  "monster-leonine-shredder": {
    "total": 2
  },
  "monster-orc-spiker": {
    "total": 2
  },
  "monster-charred-bruin": {
    "total": 2
  },
  "monster-blazing-grimalkin": {
    "total": 2
  },
  "monster-pyre-viper": {
    "total": 2
  },
  "monster-phoenix": {
    "total": 2
  },
  "monster-hellhound": {
    "total": 2
  },
  "monster-tenebrate": {
    "total": 2
  },
  "monster-dusk-hunter": {
    "total": 2
  },
  "monster-desmodic": {
    "total": 2
  },
  "monster-life-drinker": {
    "total": 2
  },
  "monster-darkling": {
    "total": 2
  },
  "monster-blackflock-conniver": {
    "total": 2
  },
  "monster-slaughterwing": {
    "total": 2
  },
  "monster-plunderwing": {
    "total": 2
  },
  "monster-blackflock-ravener": {
    "total": 2
  },
  "monster-blackflock-assassin": {
    "total": 2
  },
  "monster-minion-of-discord": {
    "total": 2
  },
  "monster-minion-of-decay": {
    "total": 2
  },
  "monster-minion-of-horror": {
    "total": 2
  },
  "monster-minion-of-war": {
    "total": 2
  },
  "monster-minion-of-neglect": {
    "total": 2
  },
  "monster-ghul": {
    "total": 2
  },
  "monster-ifrit": {
    "total": 2
  },
  "monster-iblis": {
    "total": 2
  },
  "monster-marid": {
    "total": 2
  },
  "monster-majnun": {
    "total": 2
  },
  "monster-lord-mortis": {
    "total": 2
  },
  "monster-the-prince": {
    "total": 2
  },
  "monster-judgement": {
    "total": 2
  },
  "monster-knightmare": {
    "total": 2
  },
  "monster-darkness": {
    "total": 2
  },
  "monster-legion-general": {
    "total": 1
  },
  "monster-legion-warrior": {
    "total": 3
  },
  "monster-legion-sorcerer": {
    "total": 3
  },
  "monster-legion-necromancer": {
    "total": 3
  },
  "monster-ebon-fume": {
    "total": 1
  },
  "monster-skaladak": {
    "total": 3
  },
  "monster-mythlurian": {
    "total": 2
  },
  "monster-tyxr-the-old": {
    "total": 2
  },
  "monster-uyril-unending": {
    "total": 2
  },
  "monster-cinder-drake": {
    "total": 2
  },
  "monster-caldera-dragon": {
    "total": 2
  },
  "monster-smokeplume-drake": {
    "total": 2
  },
  "monster-ash-dragon": {
    "total": 2
  },
  "monster-magma-wyrm": {
    "total": 2
  },
  "monster-skywyrm-overlord": {
    "total": 1
  },
  "monster-skywyrm-scavenger": {
    "total": 3
  },
  "monster-skywyrm-mage": {
    "total": 2
  },
  "monster-skywyrm-warrior": {
    "total": 2
  },
  "monster-skywyrm-priest": {
    "total": 2
  },
  "monster-rockslide": {
    "total": 1
  },
  "monster-aftershock": {
    "total": 3
  },
  "monster-eruptor": {
    "total": 2
  },
  "monster-scree": {
    "total": 2
  },
  "monster-tremorfiend": {
    "total": 2
  },
  "monster-blood-torment": {
    "total": 1
  },
  "monster-steam-torment": {
    "total": 3
  },
  "monster-lava-torment": {
    "total": 2
  },
  "monster-smoke-torment": {
    "total": 2
  },
  "monster-shadow-torment": {
    "total": 2
  },
  "monster-geyser-salamander": {
    "total": 2
  },
  "monster-steam-salamander": {
    "total": 2
  },
  "monster-molten-salamander": {
    "total": 2
  },
  "monster-fume-salamander": {
    "total": 2
  },
  "monster-sulphur-salamander": {
    "total": 2
  },
  "monster-frost-giant": {
    "total": 2
  },
  "monster-stone-giant": {
    "total": 2
  },
  "monster-titan": {
    "total": 2
  },
  "monster-mountain-giant": {
    "total": 2
  },
  "monster-fire-giant": {
    "total": 2
  },
  "monster-thieving-cur": {
    "total": 2
  },
  "monster-packhunter-gnoll": {
    "total": 2
  },
  "monster-marauder-gnoll": {
    "total": 2
  },
  "monster-alpha-gnoll": {
    "total": 2
  },
  "monster-scavenging-cur": {
    "total": 2
  },
  "monster-horde": {
    "total": 10
  },
  "monster-night-howler": {
    "total": 1
  },
  "monster-erynth-grask": {
    "total": 3
  },
  "monster-yellow-swarm": {
    "total": 2
  },
  "monster-edacious-destroyer": {
    "total": 2
  },
  "monster-tetrahydra": {
    "total": 2
  },
  "monster-discord-incarnate": {
    "total": 2
  },
  "monster-decay-incarnate": {
    "total": 2
  },
  "monster-horror-incarnate": {
    "total": 2
  },
  "monster-war-incarnate": {
    "total": 2
  },
  "monster-neglect-incarnate": {
    "total": 2
  },
  "monster-tactile-host": {
    "total": 1
  },
  "monster-terror-bird": {
    "total": 3
  },
  "monster-ravage-bear": {
    "total": 2
  },
  "monster-warrior-host": {
    "total": 2
  },
  "monster-ocular-host": {
    "total": 2
  },
  "monster-drakeclan-cutter": {
    "total": 3
  },
  "monster-drakeclan-ambusher": {
    "total": 3
  },
  "monster-drakeclan-laird": {
    "total": 2
  },
  "monster-drakeclan-shaman": {
    "total": 2
  },
  "monster-callerail": {
    "total": 2
  },
  "monster-mesomeme": {
    "total": 2
  },
  "monster-cragworm": {
    "total": 2
  },
  "monster-travonis-ul": {
    "total": 2
  },
  "monster-jiriskar": {
    "total": 2
  },
  "monster-ogrillon": {
    "total": 3
  },
  "monster-ogre": {
    "total": 3
  },
  "monster-ettin": {
    "total": 2
  },
  "monster-ogre-mage": {
    "total": 2
  },
  "monster-black-slime": {
    "total": 2
  },
  "monster-green-blob": {
    "total": 2
  },
  "monster-red-jelly": {
    "total": 2
  },
  "monster-gray-ooze": {
    "total": 2
  },
  "monster-noxious-slag": {
    "total": 2
  },
  "monster-greater-viscoid": {
    "total": 1
  },
  "monster-blue-viscoid": {
    "total": 1
  },
  "monster-slithering-ooze": {
    "total": 1
  },
  "monster-red-viscoid": {
    "total": 1
  },
  "monster-green-viscoid": {
    "total": 1
  },
  "monster-gelatinous-cube": {
    "total": 1
  },
  "monster-stalking-stalactite": {
    "total": 1
  },
  "monster-black-viscoid": {
    "total": 1
  },
  "monster-mucilaginous-mass": {
    "total": 1
  },
  "monster-jelly-blebs": {
    "total": 1
  },
  "monster-huntsman": {
    "total": 2
  },
  "monster-guardsman": {
    "total": 2
  },
  "monster-weapons-master": {
    "total": 2
  },
  "monster-chiurgeon": {
    "total": 2
  },
  "monster-guard-captain": {
    "total": 2
  },
  "monster-spider-queen": {
    "total": 1
  },
  "monster-firefang": {
    "total": 3
  },
  "monster-dread": {
    "total": 2
  },
  "monster-green-spinner": {
    "total": 2
  },
  "monster-widowmaker": {
    "total": 2
  },
  "monster-troll-skullcracker": {
    "total": 2
  },
  "monster-troll-osteomancer": {
    "total": 2
  },
  "monster-troll-bonebreaker": {
    "total": 2
  },
  "monster-troll-marrowgaunt": {
    "total": 2
  },
  "monster-troll-spinecutter": {
    "total": 2
  },
  "monster-ellnoica": {
    "total": 2
  },
  "monster-nibovian-wife": {
    "total": 2
  },
  "monster-pallone": {
    "total": 2
  },
  "monster-abykos": {
    "total": 2
  },
  "monster-jurulisk": {
    "total": 2
  },
  "monster-lord-of-death": {
    "total": 1
  },
  "monster-kingdom": {
    "total": 3
  },
  "monster-famine": {
    "total": 2
  },
  "monster-harbinger": {
    "total": 2
  },
  "monster-suffering": {
    "total": 2
  },
  "monster-soulstolen": {
    "total": 10
  },
  "monster-lich-lord": {
    "total": 1
  },
  "monster-grave-knight": {
    "total": 3
  },
  "monster-tomb-haunt": {
    "total": 2
  },
  "monster-deathbringer": {
    "total": 2
  },
  "monster-destiny": {
    "total": 2
  },
  "monster-walking-scourge": {
    "total": 1
  },
  "monster-plaguebearer": {
    "total": 3
  },
  "monster-hungry-dead": {
    "total": 2
  },
  "monster-plague-zombie": {
    "total": 2
  },
  "monster-restless-corpse": {
    "total": 2
  },
  "monster-shrouded-cadaver": {
    "total": 2
  },
  "monster-dwarven-ancestor": {
    "total": 2
  },
  "monster-necrophidius": {
    "total": 2
  },
  "monster-ossuous": {
    "total": 2
  },
  "monster-warrior-bones": {
    "total": 2
  },
  "monster-souleater": {
    "total": 1
  },
  "monster-cruel-apparition": {
    "total": 3
  },
  "monster-will-o-the-wisp": {
    "total": 2
  },
  "monster-wight": {
    "total": 2
  },
  "monster-devourer": {
    "total": 2
  },
  "monster-haunt": {
    "total": 2
  },
  "monster-ghost": {
    "total": 2
  },
  "monster-wraith": {
    "total": 2
  },
  "monster-revenant": {
    "total": 2
  },
  "monster-spectre": {
    "total": 2
  },
  "monster-scabbark": {
    "total": 1
  },
  "monster-canker-treant": {
    "total": 3
  },
  "monster-thorned-walker": {
    "total": 2
  },
  "monster-withered-dryad": {
    "total": 2
  },
  "monster-decayed-heartwood": {
    "total": 2
  },
  "monster-steel-spider": {
    "total": 1
  },
  "monster-stratharian-war-moth": {
    "total": 3
  },
  "monster-scutimorph": {
    "total": 2
  },
  "monster-slicer-beetle": {
    "total": 2
  },
  "monster-laak": {
    "total": 2
  },
  "monster-poison-skeleton": {
    "total": 2
  },
  "monster-zombie-mob": {
    "total": 2
  },
  "monster-filth-queen": {
    "total": 2
  },
  "monster-bloodbound": {
    "total": 2
  },
  "monster-vampiric-minion": {
    "total": 2
  },
  "monster-cavernmaw": {
    "total": 1
  },
  "monster-mancatcher-worm": {
    "total": 3
  },
  "monster-purple-worm": {
    "total": 2
  },
  "monster-albino-worm": {
    "total": 2
  },
  "monster-rot-grub": {
    "total": 2
  },
  "bearer-heart-of-doom": {
    "total": 1
  },
  "bearer-goron-singlmind": {
    "total": 1
  },
  "bearer-stramst": {
    "total": 1
  },
  "bearer-xobmokt-ichor-king": {
    "total": 1
  },
  "bearer-phylethis": {
    "total": 1
  },
  "bearer-sarrak": {
    "total": 1
  },
  "bearer-wraithlyn-dragon-general": {
    "total": 1
  },
  "bearer-the-last-doomknight": {
    "total": 1
  },
  "bearer-void-apocalypse": {
    "total": 1
  },
  "bearer-oblivion-deathkeeper": {
    "total": 1
  },
  "bearer-mowtil-djinni-lich": {
    "total": 1
  },
  "bearer-orseg": {
    "total": 1
  },
  "bearer-king-caelan": {
    "total": 1
  },
  "bearer-convergence-master": {
    "total": 1
  },
  "bearer-belac": {
    "total": 1
  },
  "village-ambrosia": {
    "total": 8
  },
  "village-animal-talisman": {
    "total": 8
  },
  "village-augmentation-amulet": {
    "total": 8
  },
  "village-backpack": {
    "total": 8
  },
  "village-bandias-wisdom": {
    "total": 8
  },
  "village-banish": {
    "total": 8
  },
  "village-bardiche": {
    "total": 8
  },
  "village-battle-scarred-soldier": {
    "total": 8
  },
  "village-bio-energy-cutter": {
    "total": 8
  },
  "village-bio-salvager": {
    "total": 8
  },
  "village-blessed-hammer": {
    "total": 8
  },
  "village-blood-debt": {
    "total": 8
  },
  "village-bloodhound": {
    "total": 8
  },
  "village-bolt-of-purity": {
    "total": 8
  },
  "village-border-guard": {
    "total": 8
  },
  "village-bounty-hunter": {
    "total": 8
  },
  "village-castellan": {
    "total": 8
  },
  "village-chalice-mace": {
    "total": 8
  },
  "village-champion-sword": {
    "total": 8
  },
  "village-charm-of-venery": {
    "total": 8
  },
  "village-chemical-injector": {
    "total": 8
  },
  "village-chieftains-drum": {
    "total": 8
  },
  "village-circle-of-protection": {
    "total": 8
  },
  "village-creeping-death": {
    "total": 8
  },
  "village-curative-draught": {
    "total": 8
  },
  "village-cursed-dagger": {
    "total": 8
  },
  "village-cursed-mace": {
    "total": 8
  },
  "village-dancing-sword": {
    "total": 8
  },
  "village-dart-thrower": {
    "total": 8
  },
  "village-debased-wizard": {
    "total": 8
  },
  "village-demon-vision": {
    "total": 8
  },
  "village-disruption-blade": {
    "total": 8
  },
  "village-doomgate-squire": {
    "total": 8
  },
  "village-dredging-net": {
    "total": 8
  },
  "village-drill-sergeant": {
    "total": 8
  },
  "village-dwarven-ale": {
    "total": 8
  },
  "village-dwarven-bear-hammer": {
    "total": 8
  },
  "village-elven-waybread": {
    "total": 8
  },
  "village-entrail-reader": {
    "total": 8
  },
  "village-falcon-arbalest": {
    "total": 8
  },
  "village-fearmaker": {
    "total": 8
  },
  "village-feast": {
    "total": 8
  },
  "village-filigree-amulet": {
    "total": 8
  },
  "village-fireball": {
    "total": 8
  },
  "village-flaming-sword": {
    "total": 8
  },
  "village-force-blast": {
    "total": 8
  },
  "village-frost-giant-axe": {
    "total": 8
  },
  "village-greatsword": {
    "total": 8
  },
  "village-guardian-blade": {
    "total": 8
  },
  "village-guide": {
    "total": 8
  },
  "village-hedge-witch": {
    "total": 8
  },
  "village-historian": {
    "total": 8
  },
  "village-hysterical-villager": {
    "total": 8
  },
  "village-icon-of-inversion": {
    "total": 8
  },
  "village-innkeeper": {
    "total": 8
  },
  "village-insight": {
    "total": 7
  },
  "village-jondul-bow": {
    "total": 8
  },
  "village-king-caelans-writ": {
    "total": 8
  },
  "village-labrys": {
    "total": 8
  },
  "village-lightstone-gem": {
    "total": 8
  },
  "village-liveoak-bow": {
    "total": 8
  },
  "village-liveoak-staff": {
    "total": 8
  },
  "village-longsword": {
    "total": 8
  },
  "village-mass-teleport": {
    "total": 8
  },
  "village-maul": {
    "total": 8
  },
  "village-mental-scrambler": {
    "total": 8
  },
  "village-mind-control": {
    "total": 8
  },
  "village-moonstone": {
    "total": 8
  },
  "village-nevajin": {
    "total": 8
  },
  "village-novice-mage": {
    "total": 8
  },
  "village-opportunist": {
    "total": 8
  },
  "village-owl-eyes": {
    "total": 8
  },
  "village-paired-swords": {
    "total": 8
  },
  "village-partisan": {
    "total": 8
  },
  "village-phase-disruptor": {
    "total": 8
  },
  "village-pike": {
    "total": 8
  },
  "village-polearm": {
    "total": 8
  },
  "village-punch-dagger": {
    "total": 8
  },
  "village-radiant-orb": {
    "total": 8
  },
  "village-rage-of-the-disowned": {
    "total": 8
  },
  "village-rangers-wilderness-map": {
    "total": 8
  },
  "village-ray-emitter": {
    "total": 8
  },
  "village-reckless-conjure": {
    "total": 8
  },
  "village-reclusive-mystic": {
    "total": 8
  },
  "village-retaliation-nodule": {
    "total": 8
  },
  "village-ritual-of-cleansing": {
    "total": 8
  },
  "village-rolling-sparks": {
    "total": 8
  },
  "village-royal-summons": {
    "total": 8
  },
  "village-runed-hammer": {
    "total": 8
  },
  "village-sage": {
    "total": 8
  },
  "village-seedbomb": {
    "total": 8
  },
  "village-shield-bearer": {
    "total": 8
  },
  "village-shock-nodule": {
    "total": 8
  },
  "village-short-bow": {
    "total": 8
  },
  "village-smuggler": {
    "total": 8
  },
  "village-snakehead-flail": {
    "total": 8
  },
  "village-soulfire": {
    "total": 8
  },
  "village-spear": {
    "total": 8
  },
  "village-stablehand": {
    "total": 8
  },
  "village-summon-aid": {
    "total": 8
  },
  "village-summon-storm": {
    "total": 8
  },
  "village-swamp-provisions": {
    "total": 8
  },
  "village-taproot-blade": {
    "total": 8
  },
  "village-thorn-caltrops": {
    "total": 8
  },
  "village-time-bend": {
    "total": 8
  },
  "village-tincture-of-victims": {
    "total": 8
  },
  "village-toryn-gauntlet": {
    "total": 8
  },
  "village-town-guard": {
    "total": 8
  },
  "village-trader": {
    "total": 8
  },
  "village-unstable-crystals": {
    "total": 16
  },
  "village-veteran-trainer": {
    "total": 8
  },
  "village-village-headman": {
    "total": 8
  },
  "village-village-jack": {
    "total": 8
  },
  "village-warder": {
    "total": 8
  },
  "basic-regular": {
    "total": 45,
    "startingDeckCount": 6,
    "purchasable": true
  },
  "basic-longspear": {
    "total": 25,
    "startingDeckCount": 2,
    "purchasable": true
  },
  "basic-torch": {
    "total": 25,
    "startingDeckCount": 2,
    "purchasable": true
  },
  "basic-thunderstone-shard": {
    "total": 10,
    "startingDeckCount": 2,
    "purchasable": false
  },
  "curse-decay": {
    "total": 4
  },
  "curse-discord": {
    "total": 4
  },
  "curse-horror": {
    "total": 4
  },
  "curse-hostility": {
    "total": 4
  },
  "curse-neglect": {
    "total": 4
  },
  "curse-shame": {
    "total": 4
  },
  "curse-sloth": {
    "total": 4
  },
  "curse-war": {
    "total": 4
  },
  "familiar-battle-hawk": {
    "total": 1
  },
  "familiar-brownie": {
    "total": 1
  },
  "familiar-dire-wolf": {
    "total": 1
  },
  "familiar-imp": {
    "total": 1
  },
  "familiar-lesser-phoenix": {
    "total": 1
  },
  "familiar-pseudodragon": {
    "total": 1
  },
  "familiar-shadow-cat": {
    "total": 1
  }
};
